import { useNavigation } from '@react-navigation/native'
import React, { useEffect, useState } from 'react'

import { LoginForm } from 'partials/LoginForm'
import { Page } from 'partials/Page'
import { SocialSignIn } from 'partials/SocialSignIn'

import { Box } from 'widgets/Box'
import { Icon } from 'widgets/Icon'
import { PressableText } from 'widgets/PressableText'
import { Text } from 'widgets/Text'

import { useAuth } from 'hooks/useAuth'

import { links } from 'utils/constants'

import { ShowUpText } from '../AuthWelcome/ShowUpText'

export const LoginPage = () => {
  const { login, ready } = useAuth()
  const navigation = useNavigation<any>()

  const [isLoginIn, setLoginIn] = useState(false)

  const usernamePassword = login?.usernamePassword
  const { isLoading, error } = usernamePassword

  const onSubmitLoginUsernamePassword = ({ email, password }: any) => {
    if (!email || !password) return
    setLoginIn(true)
    usernamePassword.mutate({
      email, // test@example.com
      password, // TestingStrongPassword
    })
  }

  const onResetPasswordPress = () => {
    navigation.navigate(links.RESET_PASSWORD_PAGE)
  }

  const onSignUpPress = () => {
    navigation.navigate(links.SIGNUP_PAGE)
  }

  useEffect(() => {
    if (error) {
      setLoginIn(false)
    }
  }, [error])

  return (
    <Page withScroll backgroundColor='black'>
      <Box display='flex' flexDirection='column'>
        <Box height={312} flexDirection='column' align='center' justifyContent='center'>
          <Box>
            <Box height={64} />
            <Icon color='v2primary' name='upspace-logo-mark' size={70} />
          </Box>
          <Box margin={{ top: 'sm' }}>
            <Icon color='white' name='upspace-word-mark' size={42} />
          </Box>
          <ShowUpText />
        </Box>
        <Box flex={1} flexDirection='column'>
          <Box>
            <LoginForm // Email, Password fields and Login button
              loading={(isLoginIn && !ready) || isLoading}
              errors={error}
              onSubmit={onSubmitLoginUsernamePassword}
            />

            <Box testID='ForgotPasswordContainer' margin={{ top: 'smd' }} align='center'>
              <PressableText bold fontSize='sm' color='v2primary' onPress={onResetPasswordPress}>
                Forgot password?
              </PressableText>
            </Box>

            {/* Separator, Google and Facebook buttons */}
            <SocialSignIn mode='login' />

            <Box
              testID='NoAccountContainer'
              align='center'
              justifyContent='center'
              flexDirection='row'
              margin={{ horizontal: 'md', vertical: 'lg' }}
              height={50}
              borderRadius='sm'
              backgroundColor='black'
            >
              <Text color='greyDark' bold fontSize='sm' align='center'>
                {"Don't have an account?  "}
              </Text>
              <PressableText bold fontSize='sm' color='v2primary' onPress={onSignUpPress}>
                Sign up
              </PressableText>
            </Box>
          </Box>
        </Box>
      </Box>
    </Page>
  )
}
